import { configPrice } from "../modules/v2/Price";

const formatPriceRP = (
  price: number,
  currency: "IDR" | "MYR" = "IDR",
  currencySymbol?: string
) => {
  const symbol = currencySymbol ?? configPrice[currency]?.prefix;
  if (!price) return `${symbol}0`;
  const result = price.toLocaleString(configPrice[currency]?.locales, {
    numberingSystem: "latn"
  } as any);
  return `${symbol}${result}`;
};
export default formatPriceRP;

